export default "__VITE_ASSET__5OlzKgKo__"